import { styled, Grid } from "@mui/material";

export const GridContainer = styled(Grid)`
  height: 100%;
`;
